import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import AIPlannerSyncBylineQuery, {
	type AIPlannerSyncBylineQuery$data,
	type AIPlannerSyncBylineQuery$variables,
} from './__generated__/AIPlannerSyncBylineQuery.graphql.ts';

export const preloadAIPlannerSyncByline = ({
	cloudId,
	contentId,
	contentType,
}: {
	cloudId: string;
	contentId: string;
	contentType: 'page' | 'blogpost';
}): ReturnType<
	typeof queryAgg<AIPlannerSyncBylineQuery$data, AIPlannerSyncBylineQuery$variables>
> => {
	const contentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;

	return queryAgg<AIPlannerSyncBylineQuery$data, AIPlannerSyncBylineQuery$variables>({
		query: AIPlannerSyncBylineQuery,
		variables: { cloudId, contentAri },
		relayQueryPreloadRetention: 'environment',
	});
};
